const LayoutErrorPage = ({ children }) => {
    return (
        <div className="w-full h-screen flex items-center justify-center bg-white text-black" >
            {children}
        </div>
    )
}

export default LayoutErrorPage;